import axiosInstance from "../Utils/axiosInterceptor";
import {Vacancy} from "../models/Vacancy";

export const VacancyService = {
    // GET /vacancies/ — list of open vacancies
    getVacancies: async (): Promise<Vacancy[]> => {
        try {
            const response = await axiosInstance.get<Vacancy[]>("/get_quick_quick_vacancies/");
            return response.data;
        } catch (error) {
            console.error('Failed to fetch vacancies:', error);
            throw error;
        }
    }
};